import React from "react";
import { NavDropdown } from "react-bootstrap";
import NavBarFL from "../../../assets/navbar-icon-bitter-reach.webp";

const session11To20Links = [
  {
    href: "/forbidden-lands-session-18",
    label: "18: Tower of the Farseers [06-21-2025]",
  },
  {
    href: "/forbidden-lands-session-16_17",
    label: "16-17: Assare's Harpoon [05-25-2025]",
  },
  {
    href: "/forbidden-lands-session-15",
    label: "15: To the Tower, Part 2 [04-26-2025]",
  },
  {
    href: "/forbidden-lands-session-14",
    label: "14: To the Tower, Part 1 [02-23-2025]",
  },
  {
    href: "/forbidden-lands-session-13",
    label: "13: The Five Seals [09-13-2024]",
  },
  {
    href: "/forbidden-lands-session-12",
    label: "12: Awakening Day [08-30-2024]",
  },
  {
    href: "/forbidden-lands-session-11",
    label: "11: Panoowa, Ghost Boy [08-02-2024]",
  },
];

const session01To10Links = [
  { href: "/forbidden-lands-session-10", label: "10: The Sting [07-19-2024]" },
  {
    href: "/forbidden-lands-session-09",
    label: "09: Aether Serpents of Ruenlocke [07-05-2024]",
  },
  {
    href: "/forbidden-lands-session-08",
    label: "08: The Crimson Raven [06-21-2024]",
  },
  {
    href: "/forbidden-lands-session-07",
    label: "07: Throwing Bones [05-31-2024]",
  },
  {
    href: "/forbidden-lands-session-06",
    label: "06: Ruins of Ruenlocke [04-19-2024]",
  },
  {
    href: "/forbidden-lands-session-05",
    label: "05: When Stars Fall [04-12-2024]",
  },
  {
    href: "/forbidden-lands-session-04",
    label: "04: Murder in Northfall [03-30-2024]",
  },
  {
    href: "/forbidden-lands-session-03",
    label: "03: Winter Spirits and Tundra Walk [03-15-2024]",
  },
  {
    href: "/forbidden-lands-session-02",
    label: "02: The Elven Lighthouse [03-02-2024]",
  },
  {
    href: "/forbidden-lands-session-01",
    label: "01: Freedom Day in Gomsten [02-02-2024]",
  },
  {
    href: "/forbidden-lands-session-00",
    label: "00: Prisoners in Gomsten [01-26-2024]",
  },
];

const campaignLinks = [
  { href: "/forbidden-lands-contests", label: "Contests" },
  { href: "/forbidden-lands-gambling", label: "Gambling" },
  { href: "/forbidden-lands-goblin", label: "Goblins" },
  { href: "/forbidden-lands-wolfkin", label: "Wolfkin" },
];

const mapLinks = [
  { href: "/forbidden-lands-campaign-maps", label: "Campaign Maps" },
];

const generatorLinks = [
  { href: "/forbidden-lands-demon-generator", label: "Generate Demon" },
  {
    href: "/forbidden-lands-adventurer-generator",
    label: "Generate Adventurer",
  },
  {
    href: "/forbidden-lands-legend-generator",
    label: "Generate Legend",
  },
  {
    href: "/forbidden-lands-stronghold-generator",
    label: "Generate Stronghold",
  },
];

const mishapLinks = [
  { href: "/forbidden-lands-magic-mishaps", label: "Spell Mishaps" },
  {
    href: "/forbidden-lands-lead-the-way-mishaps",
    label: "Lead the Way Mishaps",
  },
  { href: "/forbidden-lands-foraging-mishaps", label: "Foraging Mishaps" },
  { href: "/forbidden-lands-hunting-mishaps", label: "Hunting Mishaps" },
  { href: "/forbidden-lands-fishing-mishaps", label: "Fishing Mishaps" },
  {
    href: "/forbidden-lands-making-camp-mishaps",
    label: "Making Camp Mishaps",
  },
  {
    href: "/forbidden-lands-sea-travel-mishaps",
    label: "Sea Travel Mishaps",
  },
];

const randomTableLinks = [
  { href: "/forbidden-lands-critical-injuries", label: "Critical Injuries" },
  { href: "/forbidden-lands-hex-traveller", label: "Hex Traveller" },
  { href: "/forbidden-lands-random-encounters", label: "Random Encounters" },
  {
    href: "/forbidden-lands-stronghold-events",
    label: "Stronghold Events",
  },
];

const vttResourceLinks = [
  {
    href: "/forbidden-lands-finds-simple-carried",
    label: "VTT Finds: Simple, Carried",
  },
  {
    href: "/forbidden-lands-finds-precious-carried",
    label: "VTT Finds: Precious, Carried",
  },
  {
    href: "/forbidden-lands-finds-precious-lair",
    label: "VTT Finds: Precious, Lair",
  },
  {
    href: "/forbidden-lands-bestiary-roll20-tokens",
    label: "VTT Tokens: Bestiary",
  },
  {
    href: "/forbidden-lands-bitter-reach-bestiary-roll20-tokens",
    label: "VTT Tokens: Bitter Reach Bestiary",
  },
];

const renderLinks = (links) =>
  links.map((item) => (
    <NavDropdown.Item key={item.href} href={item.href}>
      {item.label}
    </NavDropdown.Item>
  ));

const ForbiddenLandsNavBar = () => {
  return (
    <NavDropdown title="Forbidden Lands" id="forbidden-lands-nav-dropdown">
      <NavDropdown.Header>
        <img src={NavBarFL} alt="Forbidden Lands" style={{ maxHeight: 85 }} />
      </NavDropdown.Header>

      <NavDropdown title="Sessions 11-20" id="forbidden-lands-sessions-11-20">
        {renderLinks(session11To20Links)}
      </NavDropdown>

      <NavDropdown title="Sessions 01-10" id="forbidden-lands-sessions-01-10">
        {renderLinks(session01To10Links)}
      </NavDropdown>

      <NavDropdown title="Campaign" id="forbidden-lands-campaign">
        {renderLinks(campaignLinks)}
      </NavDropdown>

      <NavDropdown title="Maps" id="forbidden-lands-maps">
        {renderLinks(mapLinks)}
      </NavDropdown>

      <NavDropdown title="Generators" id="forbidden-lands-generators">
        {renderLinks(generatorLinks)}
      </NavDropdown>

      <NavDropdown title="Mishaps" id="forbidden-lands-mishaps">
        {renderLinks(mishapLinks)}
      </NavDropdown>

      <NavDropdown title="Random Tables" id="forbidden-lands-random-tables">
        {renderLinks(randomTableLinks)}
      </NavDropdown>

      <NavDropdown title="VTT Resources" id="forbidden-lands-vtt-resources">
        {renderLinks(vttResourceLinks)}
      </NavDropdown>
    </NavDropdown>
  );
};

export default ForbiddenLandsNavBar;
